import type { NsPanelAttributes } from '@connectedhomes/nucleus/types/nucleus';

export type NsPanelProps = NsPanelAttributes & {
  testId?: string;
  className?: string;
};

export const NsPanel = ({
  children,
  testId,
  decoration,
  className,
  ...rest
}: NsPanelProps) => {
  return (
    <ns-panel
      data-testid={testId}
      decoration={decoration}
      {...{ class: className }}
      {...rest}
    >
      {children}
    </ns-panel>
  );
};
